import { render } from "./RegisterStep4.vue?vue&type=template&id=7a174acc&scoped=true&lang=pug"
import script from "./RegisterStep4.vue?vue&type=script&lang=js"
export * from "./RegisterStep4.vue?vue&type=script&lang=js"

import "./RegisterStep4.vue?vue&type=style&index=0&id=7a174acc&scoped=true&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a174acc"]])

export default __exports__